<app-scotty-spinner-overlay *ngIf="isLoading" text="Loading events..."></app-scotty-spinner-overlay>

<div class="container">
  <div class="buttons">
    <button mat-stroked-button color="primary" (click)="addEvent(null, EventType.PLANNED_MAINTENANCE)">
      <mat-icon>add</mat-icon>
      {{ 'New planned maintenance' | translate }}
    </button>
    <button [ngSwitch]="calendarOptions.initialView" mat-stroked-button color="primary" (click)="switchView()">
      <mat-icon>calendar_today</mat-icon>
      <ng-container *ngSwitchCase="CalendarView.MONTH">
        {{ 'Weekly view' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="CalendarView.WEEK">
        {{ 'Monthly view' | translate }}
      </ng-container>
    </button>
  </div>
  <full-calendar [options]="calendarOptions"></full-calendar>
</div>
